module.exports = __webpack_public_path__ + "media/1700-1_YR_2021_SocialEngineering.0496c606.mp4";